import { Injectable, inject } from "@angular/core";
import { Installation, InstallationAPI } from "./installation.model";
import { filter, map, tap } from "rxjs/operators";
import { BehaviorSubject, catchError, EMPTY, Observable, of } from "rxjs";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { MatSort } from "@angular/material/sort";
import { API_URL } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class InstallationsService {
  private http = inject(HttpClient);

  installationsAPIBS$: BehaviorSubject<InstallationAPI> =
    new BehaviorSubject<InstallationAPI>(null);
  installationsAPI$ = this.installationsAPIBS$.pipe(
    filter((res) => res != null && res.content != null),
    tap((res) => {
      this.instCount = res.numberOfElements;
      this.pageSize = res.size;
      this.numberOfPages = res.totalPages;
      this.totalNumberOfInst = res.totalElements;
    }),
  );
  installations$ = this.installationsAPI$.pipe(
    filter((res) => res != null),
    map((i) => {
      const ins = i.content.filter((i) => i != null && i.uuid != null);
      ins.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
      return ins;
    }),
  );

  instCount: number;
  pageSize: number;
  numberOfPages: number;
  totalNumberOfInst: number;

  selectedInstallationBS$: BehaviorSubject<Installation> =
    new BehaviorSubject<Installation>(null);
  selectedInstallation$ = this.selectedInstallationBS$.asObservable();

  isUpdating = new BehaviorSubject<boolean>(false);

  getInstallation(uuid: string): Installation {
    return this.installationsAPIBS$.value.content.find((i) => i.uuid === uuid);
  }

  getInstallationsBySearchForCustomer(
    customerUuid: string | null,
    searchText = "",
    pageNumber = 0,
    pageSize = 10,
  ) {
    return this.getInstallations(
      customerUuid,
      searchText,
      pageNumber,
      pageSize,
    ).pipe(filter((res) => res != null));
  }

  getInstallations(
    customerUuid: string | null,
    searchText = "",
    pageNumber = 0,
    pageSize = 20,
    sort = new MatSort(),
  ): Observable<InstallationAPI> {
    if (!sort || !sort.active || !sort.direction) {
      sort.active = "name";
      sort.direction = "asc";
    }
    let prm = new HttpParams()
      .set("search", searchText)
      .set("page", pageNumber.toString())
      .set("size", pageSize.toString())
      .set("sort", sort?.active + "," + sort?.direction);

    if (customerUuid != null) {
      prm = prm.append("customerUuid", customerUuid);
    }

    return this.http
      .get<InstallationAPI>(API_URL + "installation/", {
        params: prm,
      })
      .pipe(catchError(() => EMPTY));
  }

  getInstallationsForCustomer(
    customerUuid: string | null,
    searchText = "",
    pageNumber = 0,
    pageSize = 10,
    sort = new MatSort(),
  ) {
    return this.getInstallations(
      customerUuid,
      searchText,
      pageNumber,
      pageSize,
      sort,
    )
      .pipe(filter((res: InstallationAPI) => res != null))
      .subscribe((insts) => {
        this.installationsAPIBS$.next(insts);
      });
  }

  updateInstallation(
    installation: Installation,
  ): Observable<HttpResponse<Installation>> {
    return this.updateInstallationForCustomer(installation);
  }

  updateInstallationForCustomer(
    inst: Installation,
  ): Observable<HttpResponse<Installation>> {
    return this.http.put<Installation>(
      API_URL + "installation/" + inst.uuid,
      inst,
      {
        observe: "response",
      },
    );
  }
}
